import { render, staticRenderFns } from "./CustomerOrderTop.vue?vue&type=template&id=52843f56&"
import script from "./CustomerOrderTop.vue?vue&type=script&lang=ts&"
export * from "./CustomerOrderTop.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerOrderTop.vue?vue&type=style&index=0&id=52843f56&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports